import { Pipe, PipeTransform } from '@angular/core';
import { BlogService } from './services/blog.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
@Pipe({
  name: 'empNameFromId'
})
export class EmpNameFromIdPipe implements PipeTransform {
  constructor(private blogService: BlogService) {
  }
  transform(employeeId: string): Observable<any> {
    if (!employeeId) {
      return of('');
    }
    return this.blogService.getEmployeeFromService()
      .pipe(map(res => {
        const empName = res['data'].find(emp => emp.employee_tag === employeeId);
        if (!empName) {
          return employeeId;
        }
        return empName.employee_name;
      }));
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/blog/emp-name-from-id.pipe.ts